// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Which timestamps the server should return on reads / notifications.
 */
export enum TimestampsToReturn {
  Source = 0,
  Server = 1,
  Both = 2,
  Neither = 3,
}
